/**
 * @desc 修改
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.ProductSizeSectionRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/ProductSizeSection/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
